import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generatePDF = (data, sites, calculateGrandAmount) => {
  const doc = new jsPDF("p", "mm", "a4");
  const siteName = sites.find((s) => s.id === data.site_id)?.site_name || "N/A";
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;
  const pageHeight = doc.internal.pageSize.getHeight();

  // 1. Outer Border
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(margin, margin, pageWidth - margin * 2, pageHeight - margin * 2);

  // 2. Header Section
  doc.setFont("times", "bold");
  doc.setFontSize(22);
  doc.text("SHREE CONSTRUCTION", pageWidth / 2, 22, { align: "center" });

  doc.setFontSize(10);
  doc.setFont("times", "normal");
  doc.text("Near Manish Tent House, Joshiyapura Bahraich-271801 Uttar Pradesh", pageWidth / 2, 28, { align: "center" });

  // Contact Info Line
  doc.line(margin, 33, pageWidth - margin, 33);
  doc.setFontSize(9);
  doc.text("CALL:- +916387501837 / +918115510300", margin + 2, 38);
  doc.setTextColor(0, 0, 255);
  doc.text("EMAIL: shreeconstruction1113@gmail.com", pageWidth - margin - 2, 38, { align: "right" });
  doc.setTextColor(0);

  // Vendor Codes Line
  doc.line(margin, 42, pageWidth - margin, 42);
  doc.setFont("times", "bold");
  doc.text("HPCL Vender Code- 50093239", margin + 2, 47);
  doc.text("GSTIN NO- 09MKUPS2697R2Z7", pageWidth - margin - 2, 47, { align: "right" });

  // 3. Invoice Details Grid
  doc.line(margin, 52, pageWidth - margin, 52);
  doc.text(`INVOICE NO :- ${data.bill_no}`, margin + 2, 58);
  doc.text(`INVOICE DATE :- ${data.date}`, pageWidth - margin - 2, 58, { align: "right" });
  doc.line(margin, 63, pageWidth - margin, 63);
  doc.text(`PO.NO:- ${data.po_number || "5300032443"}`, margin + 2, 69);
  doc.text(`NAME OF WORK:- TANK INST.`, pageWidth - margin - 2, 69, { align: "right" });
  doc.line(margin, 74, pageWidth - margin, 74);

  // 4. Data Processing
  const rows = [];
  data.items.forEach((item) => {
    // Parent Item Row
    rows.push([
      { content: item.tender_line, styles: { fontStyle: "bold" } },
      { content: item.description, styles: { fontStyle: "bold" } },
      { content: item.unit, styles: { fontStyle: "bold", halign: "center" } },
      "", "", "", 
      { content: "TOTAL", styles: { fontStyle: "bold", halign: "center" } }, 
      { content: item.total_qty.toFixed(3), styles: { fontStyle: "bold", halign: "right" } },
      item.rate.toFixed(2),
      { content: item.amount.toFixed(2), styles: { fontStyle: "bold", halign: "right" } },
    ]);

    // Sub-measurements
    if (item.measurements && item.measurements.length > 0) {
      item.measurements.forEach((m) => {
        rows.push([
          "",
          { content: m.sub_description || "", styles: { fontStyle: "italic", fontSize: 7 } },
          "",
          m.qty_nos || "",
          m.length || "",
          m.width || "",
          m.height || "",
          (Number(m.total) || 0).toFixed(3),
          "", ""
        ]);
      });
    }
    // Spacer
    rows.push([{ content: "", colSpan: 10, styles: { minCellHeight: 3, border: 0 } }]);
  });

  // 5. Generate the Table
  autoTable(doc, {
    startY: 74,
    margin: { left: margin, right: margin },
    head: [["LINE. NO", "ITME DISCRIPTION", "UNIT", "NOS", "L", "W", "H/D", "QTY", "RATE", "AMOUNT"]],
    body: rows,
    theme: "grid",
    styles: { font: "times", fontSize: 7.5, textColor: 0, lineColor: 0 },
    headStyles: { fillColor: 255, textColor: 0, lineWidth: 0.1, halign: "center" },
    columnStyles: {
      0: { cellWidth: 12, halign: "center" },
      1: { cellWidth: 55 },
      2: { halign: "center", cellWidth: 15 },
      3: { halign: "center", cellWidth: 10 },
      4: { halign: "center", cellWidth: 10 },
      5: { halign: "center", cellWidth: 10 },
      6: { halign: "center", cellWidth: 12 },
      7: { halign: "right", cellWidth: 18 },
      8: { halign: "right", cellWidth: 15 },
      9: { halign: "right", cellWidth: 20 },
    },
  });

  // 6. Summary and Signature
  let finalY = doc.lastAutoTable.finalY + 15;

  // Check if we need a new page for footer
  if (finalY > pageHeight - 40) {
    doc.addPage();
    finalY = 20;
    // Re-draw border on new page if desired
    doc.rect(margin, margin, pageWidth - margin * 2, pageHeight - margin * 2);
  }

  doc.setFont("times", "bold");
  doc.setFontSize(11);
  doc.text(
    `Grand Total: INR ${calculateGrandAmount().toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    })}`,
    pageWidth - margin - 5,
    finalY,
    { align: "right" }
  );

  // Signature Block
  const sigY = finalY + 30;
  doc.setFontSize(10);
  doc.text("__________________________", margin + 15, sigY);
  doc.text("Receiver's Signature", margin + 18, sigY + 5);

  doc.text("For SHREE CONSTRUCTION", pageWidth - margin - 50, sigY - 10);
  doc.text("__________________________", pageWidth - margin - 55, sigY);
  doc.text("Authorized Signatory", pageWidth - margin - 50, sigY + 5);

  doc.save(`MB_${data.bill_no}_${siteName}.pdf`);
};